import { queryOptions } from "@tanstack/react-query";
import { accountClient } from "../client";

/** The emails the signed-in user may turn off, and which are off (ADR-149, point 7): possibly none. */
export const preferencesQuery = queryOptions({
  queryKey: ["notifications", "preferences"],
  queryFn: () => accountClient().listMyNotificationPreferences(),
});
